import { NgModule } from '@angular/core';
import { MimicViewerComponent } from './components/mimic-viewer-component/mimic-viewer.component';
import { NgxViewerComponent } from './ngx-viewer.component';
import { MimicActionsService } from './services/mimic-actions.service';
import { ColorDeciderService } from './services/color-decider.service';
import { ElementsEventListenerService } from './services/elements-event-listener.service';
import { FlagsService } from './services/channel-flags.service';
import { ColorAnimationService } from './services/color-animation.service';

@NgModule({
    declarations: [NgxViewerComponent, MimicViewerComponent],
    imports: [],
    providers: [
        MimicActionsService,
        ColorDeciderService,
        ElementsEventListenerService,
        FlagsService,
        ColorAnimationService,
    ],
    exports: [MimicViewerComponent],
})
export class MimicViewerModule {}
